
export class WpProviderReport {
    constructor(
        public id?: number,
        public providerName?: string,
        public primaryContactFirstName?: string,
        public primaryContactLastName?: string,
        public primaryAddrLine1?: string,
        public primaryAddrLine2?: string,
        public primaryCity?: string,
        public primaryState?: string,
        public primaryZip5?: string,
        public primaryZip4?: string,
        public primaryPhoneNumber?: string,
        public primaryFaxNumber?: string,
        public primaryEmail?: string,
        public providerBeginDt?: any,
        public providerEndDt?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/ProviderReport.model.ts